(function ($, DGS) {
  window.DGS.OnLoad.getInstance().register(function () {
    var $openIcon = $('#header .profile-user'),
      $navigationPanel = $('#header div.row:first-child'),
      $navigation = $('#myNav .overlay-content'),
      expandAnimDurationMS = 500,
      expandedWidth = $navigation.outerWidth() * -1;

    // Hide initially until its in place
    $navigationPanel.hide();

    /**
     * Make sure content is loaded and assign header offset
     */
    DGS.OnContentLoaded.getInstance().register(function () {
      $navigationPanel.show();
      var topOffset = $('#header .mobile-section .header-mobile-top').outerHeight();
      $navigationPanel.css('top', topOffset);
      $navigationPanel.css('right', expandedWidth);

      /**
       * Hide User-Icon if Anonymous panel is around
       */
      if ($('#header .extranet-menu-anonymous').length) {
        $openIcon.hide();
      } else {
        $openIcon.show();
      }
    });

    /**
     * Register clicks
     */
    $openIcon.click(function () {
      if ($navigationPanel.hasClass('.panel-expanded')) {
        $navigationPanel.animate({
          right: expandedWidth
        }, expandAnimDurationMS);
        $navigationPanel.removeClass('.panel-expanded');
      } else {
        $navigationPanel.animate({
          right: '0'
        }, expandAnimDurationMS);
        $navigationPanel.addClass('.panel-expanded');
      }
    });
  });
})(jQuery, window.DGS);